var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(-121 -2638)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 99,
    height: 99,
    transform: "translate(121 2638)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509",
    transform: "translate(122 2640)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M81.09,81H3.5A3.5,3.5,0,0,1,0,77.48V20.32a3.5,3.5,0,0,1,3.5-3.5H81.09a3.5,3.5,0,0,1,3.5,3.5V77.48A3.5,3.5,0,0,1,81.09,81ZM7,74H77.59V23.82H7Z",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M43.23,55.86a3.52,3.52,0,0,1-2.22-.8L2.49,23.3a3.5,3.5,0,0,1,2.22-6.2H80.64a3.5,3.5,0,0,1,2.27,6.17L45.5,55A3.51,3.51,0,0,1,43.23,55.86ZM14.46,24.1,43.2,47.79,71.11,24.1Z",
    fill: "#a8a8a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_511",
    "data-name": "Path 511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M84.36,0a13,13,0,1,1-13,13A13,13,0,0,1,84.36,0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M84.36,9a4,4,0,1,0,4,4,4,4,0,0,0-4-4m0-9a13,13,0,1,1-13,13A13,13,0,0,1,84.36,0Z",
    fill: "#707070"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailNotification);
export default __webpack_public_path__ + "static/media/email-notification.59a66bf8c0d2280bd908b7ce9922ec9d.svg";
export { ForwardRef as ReactComponent };